import { enqueueSnackbar } from 'notistack';
import axiosInstance, { endpoints } from 'src/utils/axios';

export async function getAllContributor(userID) {
  // console.log( `Envoi d'une requête pour récupérer les intervenant de l'organisme avec ID ${userID}` );
  try {
    const response = await axiosInstance.get(
      `${endpoints.contributor.getAll}/${userID}/contributors`
    );
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}

export async function deleteContributor(contributorObject) {
  // console.log("Envoi d'une requête pour supprimer  l'utilisateur:", contributorObject);
  try {
    const response = await axiosInstance.post(endpoints.contributor.delete, {
      ...contributorObject,
    });
    // console.log('Réponse de la requête :', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}
